import * as React from "react"
const BigBenClock = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={24}
    height={24}
    transform="rotate(-45)"
    viewBox="0 0 511.984 511.984"
    {...props}
  >
    <path
      d="M255.992 53.326c-5.89 0-10.656-4.781-10.656-10.672V10.655A10.648 10.648 0 0 1 255.992 0a10.648 10.648 0 0 1 10.656 10.655v31.999c0 5.891-4.765 10.672-10.656 10.672z"
      style={{
        fill: "#434a54",
      }}
    />
    <path
      d="m296.521 78.919-31.998-42.655a10.658 10.658 0 0 0-8.531-4.265 10.658 10.658 0 0 0-8.531 4.265l-31.999 42.655a10.663 10.663 0 0 0-1 11.172 10.67 10.67 0 0 0 9.531 5.906h63.997a10.67 10.67 0 0 0 9.531-5.906 10.627 10.627 0 0 0-1-11.172z"
      style={{
        fill: "#656d78",
      }}
    />
    <path
      d="M287.99 74.653h-63.997c-5.89 0-10.656 4.781-10.656 10.672v42.671a10.648 10.648 0 0 0 10.656 10.655h63.997a10.648 10.648 0 0 0 10.656-10.655V85.325c0-5.891-4.765-10.672-10.656-10.672z"
      style={{
        fill: "#e9573f",
      }}
    />
    <path
      d="m328.521 164.261-32-42.671a10.656 10.656 0 0 0-8.531-4.266h-63.997a10.656 10.656 0 0 0-8.531 4.266l-31.999 42.671a10.63 10.63 0 0 0-1 11.155 10.64 10.64 0 0 0 9.531 5.906H319.99a10.64 10.64 0 0 0 9.531-5.906c1.813-3.61 1.438-7.937-1-11.155z"
      style={{
        fill: "#fc6e51",
      }}
    />
    <path
      d="M319.99 319.99H191.994a10.65 10.65 0 0 0-10.656 10.656v170.666c0 5.891 4.765 10.672 10.656 10.672H319.99c5.891 0 10.656-4.781 10.656-10.672V330.646a10.65 10.65 0 0 0-10.656-10.656zM319.99 159.995H191.994a10.65 10.65 0 0 0-10.656 10.656v31.999c0 5.89 4.765 10.671 10.656 10.671H319.99c5.891 0 10.656-4.781 10.656-10.671v-31.999a10.65 10.65 0 0 0-10.656-10.656z"
      style={{
        fill: "#e9573f",
      }}
    />
    <path
      d="M234.649 373.316c-5.875 0-10.656 4.766-10.656 10.672v127.996h21.343V383.988c0-5.906-4.781-10.672-10.687-10.672zM277.336 373.316c-5.906 0-10.688 4.766-10.688 10.672v127.996h21.342V383.988c0-5.906-4.779-10.672-10.654-10.672zM331.334 181.322H180.651c-5.875 0-10.656 4.766-10.656 10.672v149.323c0 5.891 4.781 10.672 10.656 10.672h150.683c5.875 0 10.656-4.781 10.656-10.672V191.994c0-5.906-4.781-10.672-10.656-10.672z"
      style={{
        fill: "#fc6e51",
      }}
    />
    <path
      d="M255.992 202.65c-35.28 0-63.998 28.718-63.998 63.998 0 35.295 28.718 63.998 63.998 63.998 35.279 0 63.998-28.703 63.998-63.998 0-35.28-28.719-63.998-63.998-63.998z"
      style={{
        fill: "#e6e9ed",
      }}
    />
    <path
      d="M255.992 277.319c-5.89 0-10.656-4.781-10.656-10.671v-42.655c0-5.906 4.766-10.672 10.656-10.672 5.891 0 10.656 4.766 10.656 10.672v42.655c0 5.89-4.765 10.671-10.656 10.671z"
      style={{
        fill: "#424953",
      }}
    />
    <path
      d="M286.164 307.49a10.677 10.677 0 0 1-7.547-3.125l-30.156-30.171a10.636 10.636 0 0 1 0-15.093c4.156-4.156 10.906-4.156 15.062 0l30.186 30.171c4.156 4.172 4.156 10.921 0 15.093a10.676 10.676 0 0 1-7.545 3.125z"
      style={{
        fill: "#424953",
      }}
    />
  </svg>
)
export default BigBenClock
